import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useQuery, useMutation } from "@apollo/client";
import {
  CREATE_RIGHT,
  UPDATE_RIGHT,
  ALL_MODULES,
} from "../../../data/RoleManagementData"; // Import your GraphQL queries and mutations
import swal from "sweetalert";
import { useState, useEffect } from "react";
import Header from "../../../components/Header";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";
import { allBanks, allCompanies } from "../../../data/Axios/queries";
import { setupManagementUrl } from "../../../config";
import { executeDynamicSubmit, fetchJsonDynamic } from "../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const setup_url = setupManagementUrl.uri;


const BankBranchesForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [Banks, setBanks] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;
      try {

         const bankResponse = await fetchJsonDynamic(
                  "allBanks",
                  null,
                  null,
                  setup_url
                );
                if (bankResponse?.results) {
                  const parsed = JSON.parse(bankResponse.results);
                  setBanks(Array.isArray(parsed) ? parsed : [])
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const initialValues = {
    bankId: props.data ? props.data.BankId : "",
    branchName: props.data ? props.data.BranchName : "",
    branchCode: props.data ? props.data.BranchCode : "",
    branchSwiftCode: props.data ? props.data.BranchSwiftCode : "",
  };

  const validationSchema = yup.object().shape({
    bankId: yup.string().required("Bank is required"),
    branchName: yup.string().required("Branch Name required"),
    branchCode: yup.string().required("Branch Code required"),
    branchSwiftCode: yup.string(),
   
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const {
      bankId,
      branchName,
      branchCode,
      branchSwiftCode,
    } = values;

    const payload = {
      bankId,
      branchName,
      branchCode,
      branchSwiftCode,
    };

    const variables = props.isEditing
      ? { id: props.data.Id, ...payload }
      : payload;

    await executeDynamicSubmit({
      mutationName: props.isEditing ? "updateBankBranches" : "createBankBranches",
      variables,
      mutationObjectName: "result",
      baseUrl: setup_url,
      isEditing: props.isEditing,
      entityName: "Bank Branch",
      onSuccess: () => {
        props.onClose();
        props.onAction();
      },
      setSubmitting,
    });
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Bank Branch" : "Create Bank Branch"}
        subtitle={
          props.isEditing
            ? "Edit an Existing Bank Branch"
            : "Create a New Bank Branch"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <FormControl fullWidth variant="filled">
                <InputLabel>Bank*</InputLabel>
                <Select
                  name="bankId"
                  value={values.bankId}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.bankId && !!errors.bankId}
                >
                  {Banks.map((bank) => (
                    <MenuItem key={bank.Id} value={bank.Id}>
                      {bank.BankName}
                    </MenuItem>
                  ))}
                </Select>
                {touched.bankId && errors.bankId && (
                  <FormHelperText error>{errors.bankId}</FormHelperText>
                )}
              </FormControl>

              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Branch Name*"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.branchName}
                name="branchName"
                error={touched.branchName && !!errors.branchName}
                helperText={touched.branchName && errors.branchName}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Branch Code*"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.branchCode}
                name="branchCode"
                error={touched.branchCode && !!errors.branchCode}
                helperText={touched.branchCode && errors.branchCode}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Swift Code "
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.branchSwiftCode}
                name="branchSwiftCode"
                error={touched.branchSwiftCode && !!errors.branchSwiftCode}
                helperText={touched.branchSwiftCode && errors.branchSwiftCode}
                sx={{ gridColumn: "span 2" }}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default BankBranchesForm;